import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import PaypalRestConnectButton from 'modules/profile/payment-gateways/integrations/paypal-rest/components/paypal-rest-connect-button';
import { PaypalRestMessages } from 'modules/profile/payment-gateways/integrations/paypal-rest/components/paypal-rest-messages';
import { usePaypalRestApi } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks';
import { PaypalRestPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/paypal-rest/types';
import { getPaypalHelpPageLink } from 'modules/profile/payment-gateways/integrations/paypal-soap/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, PaypalLogoIcon } from '@systemeio/ui/icons';
export const PaypalRest: FC = () => {
  const $ = _c(5);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  const title = getPaymentProcessorTitle(PaymentProcessorEnum.PaypalRest);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.PaypalRest
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const paypalRestIntegration = t0;
  const {
    disconnect
  } = usePaypalRestApi();
  const onDelete = async () => {
    await disconnect();
    await removePaymentIntegration({
      processor: PaymentProcessorEnum.PaypalRest
    });
    toast.success(t("dashboard.settings.payment-gateways.account_removed", {
      payment: title
    }));
  };
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PaypalLogoIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = user?.dashboardLocale;
  let t3;
  if ($[3] !== t2) {
    t3 = getPaypalHelpPageLink(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return <Integration logo={t1} additionalInfo={<a className="primary-link" href={t3} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
      integration: title
    }} /></a>}>{paypalRestIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{paypalRestIntegration.details && paypalRestIntegration.details.merchantId !== null && <p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.merchant_id")}:`}</span><span className="text-text-primary truncate">{paypalRestIntegration.details.merchantId}</span></p>}{!paypalRestIntegration.readyToUse && <><p className="text-yellow">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p><PaypalRestMessages /></>}</div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
        payment: title
      })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
        payment: title
      })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.paypal")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <PaypalRestConnectButton />}</Integration>;
};